@if ((useLazyLoad || isLoaded) && !isIncomplete) {
  <sd-heading
    [sdSpyTarget]="componentUid"
    [heading]="heading"
    [readMore]="readMore"
    [titleLevel]="titleLevel"
    [titleThemesConfig]="theme"
    [isUnderlined]="isUnderlined"
    [size]="size"
    [textConfig]="textConfig"
    [brand]="brandCorner"
    [isLoading]="useLazyLoad && !isLoaded"
  />
}
